import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="bg-white shadow-md py-4">
      <div className="container mx-auto px-4 flex items-center justify-between">

        {/* Left: Logo */}
        <div className="flex items-center">
          <img
            src="/mtclogo.svg"
            alt="MTC Logo"
            className="h-12 w-auto mr-4"
          />
        </div>

        {/* Center: Navigation Links */}
        <div className="flex space-x-8 font-heading text-2xl">
          <Link
            to="/"
            className="text-primary hover:underline transition duration-200"
          >
            Home
          </Link>
          <Link
            to="/cars-for-sale"
            className="text-primary hover:underline transition duration-200"
          >
            Cars for Sale
          </Link>
          <Link
            to="/contact"
            className="text-primary hover:underline transition duration-200"
          >
            Contact Us
          </Link>
        </div>

        {/* Right: Address */}
        <div className="hidden md:block text-right font-heading text-lg text-primary">
          <p>7433 1st Ave N</p>
          <p>Birmingham, AL 35206</p>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
